import BrowserDetect from './browserDetect';
import Events from '@wwdev/bootstrap/Events';
import jQuery from 'jquery-validation';
import recaptcha from './recaptcha';

var activeLanguage = window.activeLanguage || 'nl';

switch (activeLanguage) {
    case 'en':
        require('./lang/en.js');
        break;
    case 'de':
        require('./lang/de.js');
        break;
    default:
        require('./lang/nl.js');
}

var forms = {
    preventSubmit:function($form){
        $form.find('.button-prevent-multiple-submit').prop('disabled', 'disabled');
    },
    reenableSubmit:function($form){
        $form.find('.button-prevent-multiple-submit').prop('disabled', false);
    },
    config : {
        lang: activeLanguage,
        unhighlight: function (element, errorClass, validClass) {
            if(!element.name) {
                console.log(' name niet gevonden', element );
                return true;
            }

            $(element).removeClass(errorClass).addClass(validClass);
            $(element.form).find("label[for='" + element.name + "']").removeClass(errorClass).addClass(validClass);

            if( this.numberOfInvalids() === 0 ){
                $(element).closest('.form-wrapper').find('.alert-danger').hide();
            }
        },

		submitHandler: function (form, e, isAjax = false, callback) {
			var $form = $(form);

			forms.preventSubmit($form);
			Events.trigger('form.submit', [form]);

			// Functie om te submitten wanneer klaar
			var doSubmit = function() {
				if (isAjax && callback) {
					callback(); // Voer de callback uit (die de AJAX doet)
				} else if (!isAjax) {
					form.submit();
				}
			};

			// Check voor recaptcha
			if ($form.hasClass('recaptcha_enabled')) {
				recaptcha($form, function(token, error) {
					if (error) {
						console.error('reCAPTCHA failed:', error);
						forms.reenableSubmit($form);
						return;
					}

					// Token is set, nu submitten
					doSubmit();
				});
			} else {
				// Geen recaptcha, direct submitten
				doSubmit();
			}

			return false;
		},
        errorPlacement : function(error, element){
            switch (element[0].type) {
                case 'radio':
                case 'checkbox':
                    error.css('display','block');
                    error.css('width','100%');
					element.parent().append(error);
                    break;
                default:
                    let $placementWrapper = element.closest('.custom-error-placement-wrapper');

                    if($placementWrapper.length > 0) {
                        let $placement = $placementWrapper.find('.custom-error-placement');
                        if($placement.length > 0) {
                            $placement.append(error);
                            return;
                        }
                    }

                    error.insertAfter(element);
                    break;
            }

        },
        invalidHandler : function(event, validator){
            var $form = $(validator.currentForm);

            // 'this' refers to the form
            var errors = validator.numberOfInvalids();
            var $messageContainer = $form.closest('.form-wrapper').find('.messages');
            if (errors) {
                $messageContainer.html('<div class="alert alert-danger">' + jQuery.validator.messages.invalidForm + '</div>');
                $messageContainer.show();
            } else {
                $messageContainer.hide();
            }
        },
        rules: {
            password_confirmation: {
                equalTo: '[name="password"]'
            }
        }
    },
    ajaxConfig : {

		submitHandler: function(form, e) {
			var $form = $(form);

			// Pass een callback mee die de AJAX doet
			forms.config.submitHandler(form, e, true, function() {
				$.ajax({
					type:'POST',
					url: $form.attr('action'),
					data: new FormData(form),
					cache: false,
					contentType: false,
					processData: false,
					dataType: 'json',
					success: forms.ajaxConfig.requestSuccess.bind(form),
					error: forms.ajaxConfig.requestError.bind(form),
					complete: forms.ajaxConfig.requestComplete.bind(form),
				});
			});

			return false;
		},

        requestSuccess : function(data){
            var $form = $(this);
            if (typeof data.redirect_url != 'undefined' && data.redirect_url != '') {
                location.href = data.redirect_url;
                return false;
            } else {
				$(this).parent().find('.ajax-errors').hide(); // hide error
                $form.html(data.success).addClass('alert alert-success');
                if ( $form.parent('[data-formsuccess]').length > 0 ) {
                    let newScrollTop = $form.parent('[data-formsuccess]').offset().top;
                    newScrollTop -= parseInt(getComputedStyle(document.documentElement)
                        .getPropertyValue('--header-height') );
                    window.scrollTo({
                        top: newScrollTop,
                        behavior : "smooth"
                    } );

                }
            }
        },

        requestError : function(data){
			$(this).parent().find('.ajax-errors').html(
				forms.ajaxConfig.composeErrorMessge(data)
			).addClass('alert alert-danger').show();
        },

        composeErrorMessge : function(data){
            let errors = '<ul>';
            for( let error in data.responseJSON.errors){
                error = data.responseJSON.errors[error];
                errors+='<li>' + error[0] + '</li>';
            }
            errors+='</ul>';

            return errors;
        },

        requestComplete : function(data){
            forms.reenableSubmit($(this));
        }
    },

    init : function(selector = 'form'){
        var $forms = $(selector);

        $forms.find('input[name=js_check]').val(escape("wielinkwebsolutions"));
        $forms.find('input[name=browser_info]').val(BrowserDetect.getInfoAsJSON());
        $forms.find('input[name=_token]').val(document.querySelector('meta[name="csrf-token"]').content);
        var $ajaxForms = $forms.filter('.form-ajax');
        var $customForms = $forms.filter('.form-custom-submit');
        var $defaultForms = $forms.filter(':not(.form-ajax):not(.form-custom-submit):not(.no-validate)');

        $defaultForms.each(function(){
            forms.config.rules.password_confirmation.equalTo = $(this).find('[name="password"]');
            $(this).validate(forms.config)
        });
        $ajaxForms.each(function(){$(this).validate($.extend(true,{},forms.config, forms.ajaxConfig))});
        $customForms.each(function(){$(this).validate($.extend(true,{},forms.config, {submitHandler: null}))});
    }
};

export default forms;
